<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title
                            class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1"
                        >
                            <v-icon class="me-1" size="small">mdi-account-multiple</v-icon>
                            Nominee List
                        </v-card-title>

                        <v-card-text>
                            <v-row class="py-2">
                                <v-col md="4" cols="12">
                                    <v-text-field
                                    v-model="search"
                                    append-inner-icon="mdi-magnify"
                                    label="Search"
                                    single-line
                                    hide-details
                                    density="compact"
                                    variant="outlined"
                                    bg-color="grey-lighten-4"
                                    class="pl-2"
                                    clearable
                                    ></v-text-field>
                                </v-col>

                                <v-col md="5" cols="12">
                                    <div class="d-flex align-center flex-column">
                                        <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                        >
                                            <v-btn
                                            prepend-icon="mdi mdi-download"
                                            variant="flat"
                                            color="success"
                                            @click="exportToCSV"
                                            >CSV</v-btn
                                            >
                                            <v-btn
                                            prepend-icon="mdi mdi-download"
                                            variant="flat"
                                            color="primary"
                                            @click="exportToExcel"
                                            >EXCEL</v-btn
                                            >
                                            <v-btn
                                            prepend-icon="mdi mdi-download"
                                            variant="flat"
                                            color="red"
                                            @click="exportToPDF"
                                            >PDF</v-btn
                                            >
                                        </v-btn-group>
                                    </div>
                                </v-col>

                                <v-col md="3" cols="12">
                                    <div class="text-right pr-2">
                                        <v-btn
                                            v-if="$insertAccess($route.fullPath)"
                                            @click="goTo('/hrm/add-nominee')"
                                            color="primary"
                                            variant="tonal"
                                            prepend-icon="mdi mdi-plus"
                                            rounded="xl"
                                        >
                                            Add Nominee
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                            
                            <v-card class="overflow-x-auto">

                                <v-data-table
                                :headers="headers"
                                :items="getSchema"
                                :loading="loading"
                                v-model:items-per-page="itemsPerPage"
                                :search="search"
                                :hover="true"
                                density="compact"
                                class="min-w-[1000px]"
                                >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item.code="{ item }">
                                        <span class="text-caption">{{ item.emp_id || item.code || '-' }}</span>
                                    </template>

                                    <template v-slot:item.user="{item}">
                                        <v-chip v-if="item.user" color="dark-lighten-1" size="small">{{ item.user?.username }} - {{ item.user?.code }}</v-chip>
                                    </template>

                                    <template v-slot:item.status="{ item }">

                                        <v-chip
                                        v-if="item.status == 1"
                                        color="success"
                                        size="small"
                                        class="text-capitalize"
                                        >Active</v-chip
                                        >
                                        <v-chip
                                        v-else
                                        color="red"
                                        size="small"
                                        class="text-capitalize"
                                        >Inactive</v-chip
                                        >
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-btn
                                        icon="mdi-pencil"
                                        size="small"
                                        variant="text"
                                        color="orange"
                                        @click="editItem(item)"
                                        v-if="$updateAccess($route.fullPath)"
                                        />
                                    </template>
                                </v-data-table>
                            </v-card> 
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

export default {
  components: {},
    data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    userDialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", sortable: false },
      { title: "Company", key: "branch.company.name", align: "left", sortable: false },
      { title: "Branch", key: "branch.name", align: "left", sortable: false },
      { title: "Employee Name", key: "employee.name", align: "left", sortable: false },
      { title: "Employee Code", key: "employee.code", align: "left", sortable: false },
      { title: "Designation", key: "employee_designation.name", align: "left", sortable: false },
      { title: "Nominee Code", key: "code", align: "left", sortable: false },
      { title: "Nominee Name", key: "name", align: "left", sortable: false },
      { title: "Father's / Husband's Name", key: "father_name", align: "left", sortable: false, },
      { title: "Mobile", key: "mobile", align: "left", sortable: false },
      { title: "Email", key: "email", align: "left", sortable: false },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {
    // if (this.$store.getters.getHrmNomineeList.length == 0) {
      this.loading = true;
      this.$store.dispatch("getHrmNomineeList").then((response) => {
        this.loading = false;
      });
    // }
  },
  computed: {
    getSchema() {
      return this.$store.getters.getHrmNomineeList;
    },
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$store.commit("setEditingNominee", item);
      console.log(item)
      this.$router.push({ path: "add-nominee" });
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Code", "Name", "Father's / Husband's Name", "Mobile", "Email",  "Status",];
      const rows = this.getSchema.map((item) => [  serialNumber++, (item.emp_id || item.code || '-'), item.name, item.father_name, item.mobile, item.email,  item.status == 1 ? "Active" : "Inactive",  ]);
      this.$exportTableToPDF( columns, rows, "Nominee List", "nominee_list_" + this.$fileDate() );
    },

    exportToExcel() {
      var data = [[ "#SL", "Code", "Name", "Father's / Husband's Name", "Mobile", "Email",  "Status", ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, (item.emp_id || item.code || '-'), item.name, item.father_name, item.mobile, item.email,  item.status == 1 ? "Active" : "Inactive", ]);
      });
      this.$exportTableToExcel(data, "nominee_list_" + this.$fileDate());
    },

    exportToCSV() {
      var data = [[ "#SL", "Code", "Name", "Father's / Husband's Name", "Mobile", "Email",  "Status", ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, (item.emp_id || item.code || '-'), item.name, item.father_name, item.mobile, item.email,  item.status == 1 ? "Active" : "Inactive",]);
      });
      this.$exportTableToCSV(data, "nominee_list_" + this.$fileDate());
    },
  },
  mounted() {},
};
</script>

<style scoped>
.v-card-title {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
}
</style>

